import instance from "../../../../shared/components/auth/service/AxiosInstance";

export const ClientSettingsService = {
  getClientSettings: () =>
    instance.get(process.env.REACT_APP_API_URL + "client/settings/all"),
}